module.exports = __webpack_public_path__ + "seasonal_fall-foliage_1.jpg";